import { ColDef } from '@ag-grid-community/core';

export const columnDefs: ColDef[] = [
  {
    headerName: 'ID',
    field: 'key',
    lockVisible: true,
    lockPosition: true,
    headerClass: 'ag-header-cell-label-left',
    filter: false,
    resizable: false,
  },
  {
    headerName: 'Name',
    field: 'value',
    lockVisible: true,
    lockPosition: true,
    headerClass: 'ag-header-cell-label-left',
    filter: false,
    resizable: false,
  },
];

export const defColumnPreferences = [
  { colId: 'key', hide: false, aggFunc: null, width: 150, pivotIndex: null, pinned: null, rowGroupIndex: null },
  { colId: 'value', hide: false, aggFunc: null, width: 400, pivotIndex: null, pinned: null, rowGroupIndex: null },
];
